import { OrganizationSettingsWrapper } from "./organization-settings";

export default function OrganizationSettingsPage() {
  return <OrganizationSettingsWrapper />;
}
